import configs from "constants/configs";
import React, { useState, useCallback, useEffect } from "react";
import Dropzone from "react-dropzone";
import { pushNotification } from "utils/notifications";

const UploadMultiFile1 = (props) => {
  let { Files, onChange, Code, readOnly } = props;
  let [files, setFiles] = useState(Files ? Files : []);
  let [file, setFile] = useState("");
  let [isLoad, setLoad] = useState("");
  useEffect(() => {
    if (isLoad === "") {
      if (typeof Files != "undefined") {
        const newFile = Files.map((item, index) => {
          if (typeof item.url === "undefined" && item !== "") {
            const link = {
              Name: item.substr(item.lastIndexOf("/") + 1),
              url: item,
            };
            if (link.url.lastIndexOf("http") == -1) {
              link.view = configs.apiViewUpload + link.url;
            } else {
              link.view = link.url;
            }
            return link;
          }
          return item;
        });
        if (newFile.length != files.length && newFile.length > 0) {
          setFiles(newFile);
          setLoad(false);
        }
      }
    }
  });
  const onDrop = useCallback(
    (acceptedFiles) => {
      for (let index = 0; index < acceptedFiles.length; index++) {
        const element = acceptedFiles[index];
        const formData = new FormData();
        formData.append("File", element);

        fetch(
          configs.apiUpload +
          "api/uploadfile/UploadFile?sCode=" +
          Code +
          "&sDuAn=Morman",
          {
            method: "POST",
            body: formData,
          }
        )
          .then((response) => response.json())
          .then((result) => {
            if (result.Error === null) {
              const link = {
                Name: result.FileName,
                url: result.FilePath,
                view: configs.apiViewUpload + result.FilePath,
              };
              files.push(link);
              setFiles(files);
              onChange(files);
              setFile(link);
            } else {
              pushNotification(result.Error, "warning", "TOP_RIGHT", 2000);
            }
          })
          .catch((error) => { });
      }
    },
    [files, onChange]
  );

  const xoaFile = useCallback(
    (index, event) => {
      files.splice(index, 1);
      onChange(files);
      if (files.length == 0) {
        setFiles([]);
      } else {
        setFiles(files);
      }
      setFile(file ? "" : index);
    },
    [files, file, onChange]
  );
  const dowloadFile = useCallback();
  return (
    <div>
      <Dropzone onDrop={onDrop}>
        {({ getRootProps, getInputProps }) => (
          <section>
            <div
              {...getRootProps({
                className: "dropzone1",
              })}
            >
              <input {...getInputProps()} />
              <button class="btn btn-info dz-message" type="button">
                <i class="ft-plus"></i> Upload File Đính kèm
              </button>
            </div>
          </section>
        )}
      </Dropzone>
      {files &&
        files.map((item, index) => (
          <div className="col-sm-12" style={{ marginTop: 15 }}>
            <a href={item.view} target="_blank" download>
              {item.Name}
            </a>
            {!readOnly && (
              <span
                title="Xóa file"
                className="xoa"
                onClick={xoaFile.bind(this, index)}
              >
                <i className="la la-close"></i>
              </span>
            )}
          </div>
        ))}

      <input type="text" className="hidden" value={file}></input>
    </div>
  );
};
export default UploadMultiFile1;
